export const getUserIp = (): Promise<string> => {
  return new Promise((resolve) => {
    fetch('https://api.ipify.org/?format=json')
      .then((res) => res.json())
      .then((data) => resolve(data.ip))
      .catch(() => resolve(''))
  })
}
